module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAfCAMAAAAyTAaFAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURUdwTBZr9RZr9g9l+Rdr9hVq9gZh8hdq9RJp9xdr9RZr9RRr9hdr9RZq9hdr9RVr+BZs9xdr9Rdr9RVp9Bhs9cLj0vwAAAAUdFJOUwCkaxD2SQdgGu+PIOI1xi9+07R5y67aZQAAAJlJREFUKM9lktkWwyAIRHGNRrOW///WBqO2wDzpPTI4KMCQKSAVMEeBHCLeHMX6MLSMrdi0MbNXOU1UfGe4jz7xwqmVm70KzKxbFmb2s9wWkqHt1ZYzoyVmeJBT54BWe3CWiSU+A0KeDyv9Z+hadCnQ+DLo0qBv58VjeDHjHmzXx0QD+LCHGE29SPrEr4f6FLcTqFSr/45T6AsVZg1VZ3je5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/honor-up.png
// module id = FpKo
// module chunks = 0